import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/regular/video.svg: path and width byte-identical (components/icons, Phase 5).
export default function RegularVideoIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 33 0 190 0 33c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM528 363.4l0-214.7L416 199l0-52.6L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5l0 241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6l0-52.6 112 50.4z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="regular/video" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 576 512" width="1.125em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}